import styled from 'styled-components';

export const Text = styled.span`
  font-size: 14;
  font-weight: 700;
`;
